export const DEFAULT_PANEL_WIDTH = 365;

// Medium-and-up fallback for the chat-panel layout; products can override this width.
export const DEFAULT_PANEL_WIDTH_WITH_CHAT_PANEL_LAYOUT = 400;
